import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import './EditRole.css';

const EditRole = () => {
  const { state } = useLocation(); // Retrieve roleId and roleName from state
  const navigate = useNavigate();

  const [role, setRole] = useState({
    id: state?.roleId || "",
    roleName: state?.roleName || "",
  });

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setRole((prev) => ({ ...prev, [name]: value }));
  };

  // Handle update functionality
  const handleUpdate = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/roles/update/${role.id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ roleName: role.roleName }),
      });

      if (response.ok) {
        alert("Role updated successfully!");
        navigate("/roleMaster"); // Navigate back to RoleMaster page
      } else {
        alert("Failed to update role.");
      }
    } catch (error) {
      console.error("Error updating role:", error);
      alert("Error updating role");
    }
  };

  // Handle cancel button
  const handleCancel = () => {
    navigate("/roleMaster"); // Navigate back to RoleMaster page
  };

  return (
    <div className="rolemaster">
      <div className="outside-role">
        {/* <h3>Role Master</h3> */}
      </div>
      <div className="editrole">
        <div className="inside-editrole">
          <h3>Edit Role</h3>
        </div>
        <div className="inside-containerbody">
          <div className="rolegroup">
            <label className="inside-label">Role ID</label>
            <input
              className="inside-input"
              value={role.id}
              readOnly // Role ID should not be editable
            />
          </div>
          <div className="rolegroup">
            <label className="inside-label">Role Name</label>
            <input
              className="inside-input"
              name="roleName"
              value={role.roleName}
              onChange={handleChange}
            />
          </div>
          <div className="roleButtons">
            <button className="role-btn" onClick={handleUpdate}>
              UPDATE
            </button>
            <button className="btn-role" onClick={handleCancel}>
              CANCEL
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditRole;
